import React from 'react';
import styles from './svg.css';

const User = () => (
  <svg
    version="1.1"
    className={styles.User}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 45 45"
  >
    <title>User</title>
    <path
      className="st0"
      d="M42.5,42.5h-2.4v-4.8c0-1.2-0.5-2.4-1.3-3.2c-3.3-3.5-11.6-5.3-16.3-5.3c-6.2,0-17.6,3.2-17.6,8.5v4.8H2.5v-4.8
  c0-7.6,13.2-10.9,20-10.9c5.1,0,14,1.9,18,6c1.3,1.3,2,3.1,2,4.9V42.5z M22.5,24.3c-5.9-0.2-10.7-5-10.7-10.9
  c-0.2-5.9,4.5-10.9,10.4-11c5.9-0.2,10.9,4.5,11,10.4c0,0.2,0,0.4,0,0.7C33.3,19.4,28.5,24.3,22.5,24.3z M22.5,4.9
  c-4.6,0-8.4,3.8-8.3,8.5c0.1,4.6,3.7,8.3,8.3,8.5c4.7,0,8.5-3.8,8.5-8.5S27.2,4.9,22.5,4.9L22.5,4.9z"
    />
  </svg>
);

export default User;



// WEBPACK FOOTER //
// ./src/assets/User.jsx